angular.module('impactx.timeline').directive('appTimeline', function () {
    return {
        scope: {
            data: '=',
            trns: '=',
            noLinks: '=',
            deliveryNoteActionFunction: '&',
            deliveryNoteActionIcon: '@',
            deliveryNoteActionTooltip: '='
        },
        restrict: 'E',
        templateUrl: 'modules/timeline/templates/timeline.html',
        controller: "TimelineCtrl",
        controllerAs: 'timlineCtrl',
    };
});